module.exports = __webpack_public_path__ + "img/washout-no.9b1a5715.svg";